import React from 'react';
import { Chip, Stack, Typography, useTheme } from '@mui/material';
import { getObjectChipProps } from '@/utils/objectChip';

export const NameDisplay = ({ title, isProspect, isProspectClosed }) => {
	const theme = useTheme();

	const chipProps = getObjectChipProps('prospect', { theme, isProspect });

	return (
		<Stack
			direction='column'
			spacing={0.5}
			width='100%'
			sx={{
				minWidth: 220,
				maxWidth: '100%',
				whiteSpace: 'normal',
				wordBreak: 'break-word',
			}}
		>
			{isProspect ? (
				<Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
					<Typography role='heading' aria-level='1' variant='deal_header'>
						{title}
					</Typography>
					{isProspectClosed ? (
						<Chip
							size='small'
							label='PROSPECT CLOSED'
							variant='outlined'
							color='error'
						/>
					) : (
						<Chip
							size='small'
							label='PROSPECT'
							variant='outlined'
							color='primary'
							sx={{
								...chipProps,
							}}
						/>
					)}
				</Stack>
			) : (
				<Typography role='heading' aria-level='1' variant='deal_header'>
					{title}
				</Typography>
			)}
		</Stack>
	);
};
